let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dSNy6")).then(() => parcelRequire('2KWgX'));